export const iconFontAwesomeHumanitarianSeedling = (
	<i className="fa-solid fa-seedling"></i>
);
